import PropTypes from "prop-types";
import { path } from "ramda";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";

import { StyledContainer } from "./styles";

const Text = (props) => {
  const { pageModule } = props;
  const text = path(["fields", "text"], pageModule);

  return <StyledContainer>{documentToReactComponents(text)}</StyledContainer>;
};

Text.propTypes = {
  pageModule: PropTypes.shape().isRequired,
};

export default Text;
